import React from "react";
import { usePastEvents } from "../util/db";
import FormAlert from "./FormAlert";
import EventsTablePast from "./EventsTablePast";
import { Card } from "react-bootstrap";

function EventsPagePast() {
  const {
    data: items,
    status: itemsStatus,
    error: itemsError,
  } = usePastEvents();

  return (
    <>
      {itemsError && (
        <div className="mb-3">
          <FormAlert type="error" message={itemsError.message} />
        </div>
      )}

      {itemsStatus !== "loading" && items && items.length > 0 && (
        <Card
          className="mb-3"
          style={{
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Card.Header
            style={{
              background: "#2D083F",
              color: "white",
              borderRadius: "10px 10px 0 0",
            }}
          >
            <Card.Title className="mb-0" style={{ color: "white" }}>
              Past Events
            </Card.Title>
          </Card.Header>
          <Card.Body style={{ background: "#FFFFFF", padding: "0" }}>
            <EventsTablePast events={items} />
          </Card.Body>
        </Card>
      )}

      {itemsStatus !== "loading" && items && items.length === 0 && (
        <Card
          className="mb-3"
          style={{
            borderRadius: "10px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <Card.Header
            style={{
              background: "#2D083F",
              color: "white",
              borderRadius: "10px 10px 0 0",
            }}
          >
            <Card.Title className="mb-0" style={{ color: "white" }}>
              Past Events
            </Card.Title>
          </Card.Header>
          <Card.Body style={{ background: "#FFFFFF" }}>
            <div className="text-center py-4">No past events found.</div>
          </Card.Body>
        </Card>
      )}
    </>
  );
}

export default EventsPagePast;
